<div class="block-lease-rows__toolbar">
  <div class="block-lease-rows__actions">
    <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_MORE" (click)="createItem()"></astral-button>
    <astral-button
      variant="primary"
      size="small"
      type="button"
      icon="plus"
      labelKey="LEASE_AGREEMENT_ROW.RENTAL_OBJECT_SUM"
      (click)="addFromRentalObjectsSum()"
    ></astral-button>
    <astral-button
      variant="primary"
      size="small"
      type="button"
      icon="plus"
      labelKey="LEASE_AGREEMENT_ROW.RENTAL_OBJECT_FETCH"
      (click)="addFromRentalObjects()"
    ></astral-button>
  </div>

  <div class="block-lease-rows__history">
    <astral-checkbox [control]="displayFormGroup.controls['displayHistory']"></astral-checkbox>
  </div>
</div>
<app-list-view
  [columnDefinition]="columnDefinition"
  [contextMenuDefinition]="menuDefinition"
  [itemsSource]="itemsSource"
  [preferencesKey]="'rent.block-lease-rows.list'"
  (rowClick)="onRowClicked($event)"
></app-list-view>

<!-- SIDEBAR content -->
<ng-template #leaseAgreementSidebarContent>
  @if (selectedRow) {
    <app-lease-row-form
      [leaseAgreementCategory]="'Block'"
      [row]="selectedRow"
      [currencyCode]="currency"
      [articles]="articles"
      [rentalObjectSelection]="rentalObjectSelection"
      [cultureName]="cultureName"
      (completed)="onCompleted($event)"
    ></app-lease-row-form>
  }
</ng-template>
